import { UserTypes } from "./UserTypes";
import { SubscriptionStatus } from "../Subscriptions/SubscriptionStatus";
import { SubscriptionRecurrenceType } from "../Subscriptions/SubscriptionRecurrenceType";
import { NutrientSource } from "../NutrientSource/NutrientSource";
import {CustomerCreationMode} from "@/models/Customer/CustomerCreationMode";
import {PaymentProvider} from "@/models/Subscriptions/PaymentProvider";

type NutritionLabelsLimit = {
  downloadedLabels: number;
  labelsLimit: number;
  nextResetDate: string;
  paidLabelsAvailable: number;
}

class UserDetails {
  constructor(
    // tslint:disable-next-line:variable-name
    private _userType: UserTypes,
    public email: string,
    protected localization: string,
    public isRecipeOrDishLimitExceeded: boolean = false,
    protected _id?: number,
    public restaurantId?: number,
    protected restaurantName?: string,
    protected subscriptionName?: string,
    public isTrial?: boolean,
    public readonly isSpecial?: boolean,
    public subscriptionStatus?: SubscriptionStatus,
    public readonly subscriptionStartDate?: Date,
    public subscriptionEndDate?: string,
    public readonly subscriptionCycle?: SubscriptionRecurrenceType,
    public readonly hasDraftSubscription?: boolean,
    protected availableNutrientSources?: NutrientSource[],
    public readonly isRecurring?: boolean,
    public readonly subscriptionPackageId?: number,
    public readonly subscriptionPackageExternalId?: string,
    public firstName?: string,
    public lastName?: string,
    public readonly restaurantNotificationEmail?: string,
    public addOns?: [],
    protected phone?: string,
    public readonly freeUserLicenses?: number,
    public readonly paidUserLicenses?: number,
    public readonly subscriptionPaymentProvider?: PaymentProvider,
    public readonly featureFlagPaymentProvider?: PaymentProvider,
    public readonly isLegacySubscription?: boolean,
    public isEnterprise: boolean = false,
    public creationMode?: CustomerCreationMode,
    public nutritionLabelsLimit: NutritionLabelsLimit = {
      downloadedLabels: 0,
      labelsLimit: 0,
      nextResetDate: '',
      paidLabelsAvailable: 0
    }
  ) {
    this._id = _id;
    this.restaurantId = restaurantId;
    this.restaurantName = restaurantName;
    this.subscriptionName = subscriptionName;
    this.subscriptionStartDate = subscriptionStartDate;
    this.subscriptionEndDate = subscriptionEndDate;
    this.subscriptionCycle = subscriptionCycle;
    this.hasDraftSubscription = hasDraftSubscription;
    this.availableNutrientSources = availableNutrientSources;
    this._userType = _userType;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.localization = localization;
    this.isTrial = isTrial;
    this.isSpecial = isSpecial;
    this.isEnterprise = isEnterprise;
    this.subscriptionStatus = subscriptionStatus;
    this.subscriptionPackageId = subscriptionPackageId;
    this.subscriptionPackageExternalId = subscriptionPackageExternalId;
    this.subscriptionPaymentProvider = subscriptionPaymentProvider;
    this.featureFlagPaymentProvider = featureFlagPaymentProvider;
    this.isLegacySubscription = isLegacySubscription;
    this.restaurantNotificationEmail = restaurantNotificationEmail;
    this.addOns = addOns;
    this.isRecurring = isRecurring;
    this.phone = phone;
    this.isRecipeOrDishLimitExceeded = isRecipeOrDishLimitExceeded;
    this.freeUserLicenses = freeUserLicenses;
    this.paidUserLicenses = paidUserLicenses;
    this.nutritionLabelsLimit = nutritionLabelsLimit;
    this.creationMode = creationMode;
  }

  get userId(): number {
    return this._id;
  }

  get userType(): UserTypes {
    return this._userType;
  }
}

export default UserDetails;
